"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const asset_detail_tab_1 = __importDefault(require("./asset-detail-tab"));
const asset_tabs_modules_less_1 = __importDefault(require("./asset-tabs.modules.less"));
const AssetTabs = () => {
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const tabContent = () => {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: asset_tabs_modules_less_1.default['review-detail__field'] },
                react_1.default.createElement("i", { className: "fal fa-share-alt" }),
                react_1.default.createElement("label", { className: asset_tabs_modules_less_1.default['review-field__label'] }, "Round ID:"),
                react_1.default.createElement("span", null,
                    "#", reviewRound === null || reviewRound === void 0 ? void 0 :
                    reviewRound.id)),
            react_1.default.createElement("div", { className: asset_tabs_modules_less_1.default['review-detail__field'] },
                react_1.default.createElement("i", { className: "fal fa-user" }),
                react_1.default.createElement("label", { className: asset_tabs_modules_less_1.default['review-field__label'] }, "Created By:"),
                react_1.default.createElement("span", null, reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.ownerName)),
            react_1.default.createElement("div", { className: asset_tabs_modules_less_1.default['review-detail__field'] },
                react_1.default.createElement("i", { className: "fal fa-calendar-alt" }),
                react_1.default.createElement("label", { className: asset_tabs_modules_less_1.default['review-field__label'] }, "Created Date:"),
                react_1.default.createElement("span", null, (0, moment_1.default)(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.createdAt, ['YYYY-MM-DD HH:mm:ss']).format('DD-MM-YYYY HH:mm'))),
            react_1.default.createElement("div", { className: asset_tabs_modules_less_1.default['review-detail__field'] },
                react_1.default.createElement("i", { className: "fal fa-share-alt" }),
                react_1.default.createElement("label", { className: asset_tabs_modules_less_1.default['review-field__label'] }, "Review Type:"),
                react_1.default.createElement("span", null, reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundType)),
            react_1.default.createElement("div", { className: asset_tabs_modules_less_1.default['review-detail__field'] },
                react_1.default.createElement("i", { className: "fal fa-share-alt" }),
                react_1.default.createElement("label", { className: asset_tabs_modules_less_1.default['review-field__label'] }, "Review Provider:"),
                react_1.default.createElement("span", null, "Ziflow"))));
    };
    const tabData = [
        {
            id: 'proofs',
            tabLabel: 'proofs',
            tabContent: react_1.default.createElement(asset_detail_tab_1.default, null),
            TabProps: {
                classes: {
                    root: asset_tabs_modules_less_1.default['tab-root__header'],
                },
            },
            TabPanelProps: {
                classes: {
                    root: 'asset-review-panel',
                },
            },
        },
        {
            id: 'review-detail',
            tabLabel: 'review detail',
            // distinguish between Finance and Non-Finance Documents
            tabContent: tabContent(),
            TabProps: {
                classes: {
                    root: asset_tabs_modules_less_1.default['tab-root__header'],
                },
            },
        },
    ];
    return (react_1.default.createElement(pulse_components_1.PulseTabs, { tabData: tabData, TabsProps: {
            classes: {
                root: 'tabs-root',
                flexContainer: 'tabs-container',
            },
            variant: 'scrollable',
            scrollButtons: false,
        } }));
};
exports.default = AssetTabs;
